/*
 * Tasks Grid — migrated from Sprockets tasks.js
 * AG Grid v35 APIs
 */
const AgGridPagination = require('../v4/components/ag_grid_pagination');

window.Tasks = {
    _gridApi: null,

    _initializePaginationListeners() {
        $('#pagination').exists().on('click', 'a[data-first]', () => this._gridApi.paginationGoToFirstPage());
        $('#pagination').exists().on('click', 'a[data-prev]', () => this._gridApi.paginationGoToPreviousPage());
        $('#pagination').exists().on('click', 'a[data-next]', () => this._gridApi.paginationGoToNextPage());
        $('#pagination').exists().on('click', 'a[data-last]', () => this._gridApi.paginationGoToLastPage());
        return $('#pagination').exists().on('click', 'a[data-go-to-page]', e => {
            const {
                pageNumber
            } = $(e.currentTarget).data();
            return this._gridApi.paginationGoToPage(pageNumber);
        });
    },

    _filters: {
        start_date: null,
        end_date: null,
        specific_date: null,
        task_names: []
    },

    _emptyFilters: {
        start_date: null,
        end_date: null,
        specific_date: null,
        task_names: []
    },

    _gridOptions: {
        headerHeight: 44,
        rowHeight: 60,
        columnDefs: null,
        rowData: null,
        pagination: true,
        suppressPaginationPanel: true,
        rowModelType: "infinite",
        paginationAutoPageSize: true,
        maxConcurrentDatasourceRequests: 2,
        cacheOverflowSize: 1,
        infiniteInitialRowCount: 1,
        maxBlocksInCache: 2,
        defaultColDef: {
            resizable: true
        },
        overlayNoRowsTemplate: `<div class="no-entries"><i class="far fas-calendar-check"></i><h3>${I18n.t('tasks.blank.header')}</h3></div>`,
        onGridSizeChanged(event) {
            return event.api.sizeColumnsToFit();
        }
    },

    _taskDescriptionRenderer(row) {
        if (row.value) {
            return row.value;
        } else {
            return I18n.t('loading');
        }
    },

    _clearFilters() {
        if (_.isEqual(this._filters, this._emptyFilters)) {
            $("#clear-filters").hide();
        } else {
            $("#clear-filters").show();
        }

        return $("#clear-filters").off().on('click', () => {
            const $taskNames = $(':checkbox[id^="task_name_"]:checked');
            $taskNames.each((i, elem) => {
                elem.checked = false;
            });

            $("#start_date").val("");
            $("#end_date").val("");
            $("#specific_date").val("");

            this._filters.start_date = null;
            this._filters.end_date = null;
            this._filters.specific_date = null;
            this._filters.task_names = [];

            return this._setRowData();
        });
    },

    _initializeFilters() {
        const $taskNames = $(':checkbox[id^="task_name_"]');

        $taskNames.click(e => {
            const taskName = _.last(e.currentTarget.id.split('task_name_'));
            if ($(e.currentTarget).is(':checked')) {
                this._filters.task_names.push(taskName);
            } else {
                this._filters.task_names = _.filter(this._filters.task_names, item => item !== taskName);
            }
            return this._setRowData();
        });

        return this._initializeDateRangeFilter();
    },

    _initializeDateRangeFilter() {
        const $specificDateField = $("#specific_date");
        const $startDateField = $("#start_date");
        const $endDateField = $("#end_date");
        const $dataRangeFields = $('#date_range_fields');
        $dataRangeFields.hide();

        $("select[id*='select_filter_date']").change(function () {
            if ($("select[id*='select_filter_date'] option:selected").val() === '1') {
                $("input[id*='specific_date']").show();
                return $dataRangeFields.hide();
            } else if ($("select[id*='select_filter_date'] option:selected").val() === '2') {
                $("input[id*='specific_date']").hide();
                return $dataRangeFields.show();
            }
        });

        $("#specific_date").click(function () {
            $startDateField.val("");
            return $endDateField.val("");
        });

        $("#start_date, #end_date").click(() => $specificDateField.val(""));

        return $("#specific_date, #start_date, #end_date").change(() => {
            this._filters.specific_date = $specificDateField.val();
            this._filters.start_date = $startDateField.val();
            this._filters.end_date = $endDateField.val();
            return this._setRowData();
        });
    },

    _setRowData() {
        this._clearFilters();
        const dataSource = {
            rowCount: null,
            getRows: params => {
                return $.ajax({
                    url: '/tasks/load_batch',
                    type: 'GET',
                    dataType: 'json',
                    data: { start_row: params.startRow, end_row: params.endRow, filters: this._filters },
                    success(data) {
                        if (data.rowsCount == 0) { Tasks._gridApi.showNoRowsOverlay() }
                        return params.successCallback(data.tasks, data.rowsCount);
                    }
                });
            }
        };
        this._gridApi.setGridOption('datasource', dataSource);
    },

    _cellRenderer(doc) {
        if (doc.data) {
            return doc.value;
        } else {
            return I18n.t('loading');
        }
    },

    initializeTaskTable() {
        const agGridPagination = AgGridPagination.initialize(this._gridOptions);
        this._gridOptions.onPaginationChanged = agGridPagination.renderPagination.bind(agGridPagination);

        const columnDefs =
            [
                { headerName: I18n.t('tasks.task_description'), field: 'link_to_task', cellRenderer: this._taskDescriptionRenderer, cellClass: 'bold', width: 350 },
                { headerName: I18n.t('tasks.due_date'), field: 'formatted_due_date', width: 130, comparator(l, r) { return l - r; } },
                { headerName: I18n.t('tasks.project_name'), field: 'project_name', width: 230, cellRenderer: this._cellRenderer },
                { headerName: I18n.t('tasks.project_ref_no'), field: 'project_ref', width: 230, cellRenderer: this._cellRenderer }
            ];

        this._gridOptions.columnDefs = columnDefs;

        this._gridOptions.onGridSizeChanged = () => {
            return this._gridApi.sizeColumnsToFit();
        };

        const gridDiv = document.getElementById('taskTable');
        this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
        this._gridOptions.api = this._gridApi;
        this._gridApi.sizeColumnsToFit();
        this._setRowData();
        this._initializeFilters();
        resizeAgGridTable("#taskTable", this._gridOptions, 0, 15);
        return AgGridPagination.initializePaginationListeners();
    }
};
